import { render, staticRenderFns } from "./PhoenixSvgSection.vue?vue&type=template&id=17b6cd74"
import script from "./PhoenixSvgSection.vue?vue&type=script&lang=js"
export * from "./PhoenixSvgSection.vue?vue&type=script&lang=js"
import style0 from "./PhoenixSvgSection.vue?vue&type=style&index=0&id=17b6cd74&prod&module=%24s&lang=scss"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports